import * as React from 'react';
import Card from './Card';
import { AddressInfo } from '../types/addressTypes';
import LinkButton from './LinkButton';
import '../css/address-card.sass';

interface AddressCardProps {
  address: AddressInfo;
  heading?: string;
  linkLbl?: string;
  bgColor?: '#f5f5f4' | '#ffffff';
  onClick?: Function;
}

export default function AddressCard(props: AddressCardProps) {
  const { bgColor = '#f5f5f4' } = props;

  return (
    <>
      <div className="address-card">
        <Card backgroundColor={bgColor}>
          {props.heading && <p className="address-header">{props.heading}</p>}
          <p className="address" id="address">
            {props.address.addressLineOne} {props.address.addressLineTwo}
            <br />
            {props.address.city}
            <br />
            {props.address.state} {props.address.zip}
          </p>
          {props.linkLbl && (
            <LinkButton
              name="Address Link"
              id="addressLink"
              forward
              onClick={() => {
                if (props.onClick !== undefined) {
                  props.onClick();
                }
              }}
            >
              {props.linkLbl}
            </LinkButton>
          )}
        </Card>
      </div>
    </>
  );
}
